import { useMemo } from 'react';
import { useAppSelector } from '../redux';

import { userSelectors } from '../redux/user';

import {
  ISubNavigationStep,
  JobOpeningCrucialRequirementCategory,
} from '../types';
import { APP_ROUTES } from '../constants';
import { getUserMissingRequirementCatagories } from 'src/utils';

export const useCrucialRequirementsNavigationSteps = () => {
  const userData = useAppSelector(userSelectors.getUserData);
  const crucialRequirements = useAppSelector(
    userSelectors.getUserCrucialRequirements,
  );

  const crucialRequirementSteps = useMemo(() => {
    const steps: ISubNavigationStep[] = [];

    steps.push({
      label: 'Tell us about yourself',
      route: '',
      isHeader: true,
      isCompleted: true,
    });

    steps.push({
      label: 'Confirm requirements',
      route: '',
      isHeader: true,
      isActive: true,
    });

    const missingCrucialRequirementCategories =
      getUserMissingRequirementCatagories(userData);

    if (
      missingCrucialRequirementCategories.includes(
        JobOpeningCrucialRequirementCategory.DomainKnowledge,
      ) ||
      missingCrucialRequirementCategories.includes(
        JobOpeningCrucialRequirementCategory.Technology,
      )
    ) {
      crucialRequirements.technology;
      const hasSelectedTech = [
        ...Array.from(Object.values(crucialRequirements.technology)),
        ...Array.from(Object.values(crucialRequirements.domainKnowledge)),
      ].some((value) => typeof value === 'boolean');

      steps.push({
        label: 'Required skills',
        route: APP_ROUTES.SKILLS_REQUIREMENTS,
        isEditable: hasSelectedTech,
      });
    }

    if (
      missingCrucialRequirementCategories.includes(
        JobOpeningCrucialRequirementCategory.Education,
      )
    ) {
      // Check if any education requirements are selected (true values in Map)
      const hasSelectedEducation = Array.from(
        Object.values(crucialRequirements.education),
      ).some((value) => typeof value === 'boolean');

      steps.push({
        label: 'Education',
        route: APP_ROUTES.EDUCATION_REQUIREMENTS,
        isEditable: hasSelectedEducation,
      });
    }

    if (
      missingCrucialRequirementCategories.includes(
        JobOpeningCrucialRequirementCategory.Visa,
      )
    ) {
      // Check if any visa requirements are selected (true values in Map)
      const hasSelectedVisa = Array.from(
        Object.values(crucialRequirements.visa),
      ).some((value) => typeof value === 'boolean');

      steps.push({
        label: 'Visa',
        route: APP_ROUTES.VISA_REQUIREMENTS,
        isEditable: hasSelectedVisa,
      });
    }

    if (
      missingCrucialRequirementCategories.includes(
        JobOpeningCrucialRequirementCategory.WorkingConditions,
      )
    ) {
      const hasSelectedWorkingConditions = Array.from(
        Object.values(crucialRequirements.workingConditions),
      ).some((value) => typeof value === 'boolean');

      steps.push({
        label: 'Working conditions',
        route: APP_ROUTES.WORKING_CONDITIONS_REQUIREMENTS,
        isEditable: hasSelectedWorkingConditions,
      });
    }

    return steps;
  }, [userData, crucialRequirements]);

  return { crucialRequirementSteps };
};
